import CurrencySwitcher from "components/CurrencySwitcher";
export default function CurrencyConverter() { return <CurrencySwitcher />; }
